<div class="container">
    <app-shell 
        style="width: 100%; height: 100%;"  
        [needsProgressBars]="false"
        [homeState]="homeState"
        [bpState]="bpState"
        [fpState]="fpState"
        [cpState]="cpState"
    >
        <div class="dashboard-grid">
            <div class="dashboard-hero tile ">
                <div class="dashboard-hero-text">
                    <h1 [innerHTML]="this.mainHeaderText"></h1>
                    <p [innerHTML]="this.mainSummaryText"></p>
                    <app-client-additional-info-request-list 
                        [typeNameAndDescriptionList]="this.mainSummaryTypeNameAndDescriptionList"
                        *ngIf="this.isClientAdditionalInfoRequest"    
                    ></app-client-additional-info-request-list>
                </div>
                <div class='button-wrapper' *ngIf="this.mainButtonText">
                    <app-stateful-primary-button 
                        text="{{this.mainButtonText}}" 
                        [pageUrl]="this.nextState['pageUrl']"
                        [stateId]="this.nextState['id']"
                        [fontSizeCssClass]="'extra-large'"
                        [clickEvent]="this.mainButtonClickEvent.bind(this)"
                    ></app-stateful-primary-button>
                </div>
            </div>

            <div class="dashboard-progress tile" *ngIf="this.isTablet">
                <h2>Onboarding Journey</h2>
                <app-dashboard-checklist [checklistItems]="this.checklistItems"
                    style="width: 85%;"></app-dashboard-checklist>
                <span id="module-approximate-time">{{this.moduleEstimateText}}</span>
            </div>

            <div class="dashboard-info tile">
                <h2>Grow Fearlessly</h2>
                <p>Explore <a href="https://nowcorp.com/clients/" target="_blank">NowAccount</a></p>
                <p>Expand with <a href="https://nownetwork.nowcorp.com/" target="_blank">NowNetwork</a></p>
            </div>

            <div class="dashboard-contact tile">
                <h4>{{this.acccountManagerContact.firstName}} {{this.acccountManagerContact.lastName}}</h4>
                <img 
                    src="\assets\images\Icon_ionic-md-contact.svg" 
                    alt="Now Representative Icon"
                    width="40"
                    height="40"
                />
                <p>{{this.acccountManagerContact.email}}</p>
                <p>{{this.acccountManagerContact.phoneNumber}}</p>
                <a href="/support/case" target="_blank" *ngIf="this.showSupportLink">Tech Support</a>
            </div>

            <div class="dashboard-progress tile" *ngIf="!this.isTablet">
                <h2>Onboarding Journey</h2>
                <app-dashboard-checklist [checklistItems]="this.checklistItems"></app-dashboard-checklist>
                <span id="module-approximate-time">{{this.moduleEstimateText}}</span>
            </div>
        </div>
    </app-shell>
</div>